$(document).ready(function() {
//   jQuery.ajax({
//     type: 'GET',
//     url: 'https://api.yotpo.com/v1/widget/CiVXTQWJKPQDTpBpVVH7Jio5qStY03R2duzV16P9/products/yotpo_site_reviews/reviews.json?per_page=30',
//     dataType: 'json',
//     success: function(data) { 
//       console.log(data)
//       const res = data.response;
//       let reviewStarsArray = '';
//       const average_score = res.bottomline.average_score;
//       for (let i = 0; i < 5; i++) {
//         reviewStarsArray += `<img src="{{ 'star.svg' | asset_url }}">`;
//       }
//       $('.product-reviews-stars').html('<a href="/pages/reviews">' + reviewStarsArray + '<span>(' + res.bottomline.total_review + ' Reviews)</span></a>');
//     },
//     error: function(){
//       console.log('Error');
//     }
//   });
  
  $('.product-reviews-stars').each(function() {
    var div = $(this);
    var url;
//     var deodorantProducts = ['833527709732', '833511915556', '833527414820', '833528528932', '833526923300', '5743593226394', '5743609086106', '5743595389082', '5743595389082'];
    var washProducts = ['7130386301082', '7130387513498', '7130388955290'];
    var link = $(this).attr('data-url');
    if ($(this).attr('data-id') == 7250571165850 || $(this).attr('data-id') == 7114026057882) {
      url = 'https://api.yotpo.com/v1/widget/CiVXTQWJKPQDTpBpVVH7Jio5qStY03R2duzV16P9/products/yotpo_site_reviews/reviews.json?per_page=7';
    } else if ($(this).attr('data-id') == 7114026647706 || $(this).attr('data-id') == 7114024255642) {
      getReviews(washProducts, div);
      return;
    } else {
      url = `https://api.yotpo.com/v1/widget/CiVXTQWJKPQDTpBpVVH7Jio5qStY03R2duzV16P9/products/${div.attr('data-id')}/reviews.json?per_page=150`;
    }
    jQuery.ajax({
      type: 'GET',
      url: url,
      dataType: 'json',
      success: function(data) { 
        const res = data.response;
        console.log(res)
        if (res && res.reviews.length && res.bottomline.total_review > 3) {
          let reviewStarsArray = '';
          let num = res.bottomline.star_distribution[4] + res.bottomline.star_distribution[5];
          const average_score = (res.bottomline.star_distribution[4]*4 + res.bottomline.star_distribution[5]*5) / num;
          for (let i = 0; i < 5; i++) {
            if ((average_score - i) >= 1) reviewStarsArray += `<div class="star"></div>`;
            else if ((average_score - i) < 1 && (average_score - i) > 0) reviewStarsArray += `<div class="star half"></div>`;
          }
          div.html('<a href="' + link + '">' + reviewStarsArray + '<span>(' + num + ')</span></a>');
        } else {
          div.hide(0);
        }
      },
      error: function(){
        console.log('Error');
      }
    })
  });
  
  function getReviews(ids, div) {
    var counter = 0;
    var average = 0;
    var num = 0;
    var link = div.attr('data-url');
    for (var i=0; i<ids.length; i++) {
      url = `https://api.yotpo.com/v1/widget/CiVXTQWJKPQDTpBpVVH7Jio5qStY03R2duzV16P9/products/${ids[i]}/reviews.json?per_page=150`;
      jQuery.ajax({
        type: 'GET',
        url: url,
        dataType: 'json',
        success: function(data) { 
          const res = data.response;
          if (res.reviews.length) {
            var review_num = res.bottomline.star_distribution[4] + res.bottomline.star_distribution[5];
            num += review_num;
            average += (res.bottomline.star_distribution[4]*4 + res.bottomline.star_distribution[5]*5) / review_num;
            counter++;
            if (counter == ids.length) {
              var average_score = average / ids.length;
              let reviewStarsArray = '';
              for (let i = 0; i < 5; i++) {
                if ((average_score - i) >= 1) reviewStarsArray += `<div class="star"></div>`;
                else if ((average_score - i) < 1 && (average_score - i) > 0) reviewStarsArray += `<div class="star half"></div>`;
              }
              div.html('<a href="' + link + '">' + reviewStarsArray + '<span>(' + num + ')</span></a>');
              div.show(0);
            }
          } 
        },
        error: function(){
          console.log('Error');
        }
      });
    }
  }
  
//   var headerHeight = $('header').outerHeight(true);
//   var  offset = headerHeight;
//   $('a[href^="#"]').click(function() {
//     var anchor = $(this).attr('href');
//     var navHeight = $('.categories-nav').height();
//     var top =  $(anchor).offset().top - $('main').offset().top - offset - navHeight;
//     $('html, body').stop().animate({
//         scrollTop: top
//     }, 500);
//   });
  
  if ($(window).width() < 1000) {
    $('.pdp-scents .carousel').scrollLeft($('.pdp-scents .scent').width()/2);
  }
  
  
  var elementPosition = $('.hero').outerHeight();
  $(window).on('scroll',function(){
//     var navHeight = $('.categories-nav').height();
//     if($(window).scrollTop() > elementPosition){
//       $('.categories-nav').css('position','fixed').css('top',offset + 'px');
//       $('.collection-categories').css('margin-top', navHeight);
//     } else {
//       $('.categories-nav').css('position','static');
//       $('.collection-categories').css('margin-top', 0);
//     }    
    
//     if ($(window).width() < 1000) {
//       $('.product-card').each(function() {
//         var image = $(this).find('.image');
//         var imageBottom = image.offset().top + image.outerHeight();
//         if ($(window).scrollTop() + $(window).height() > imageBottom + image.outerHeight()/3 && $(window).scrollTop() < imageBottom - image.outerHeight()){
//           image.addClass('hovered');
//         } else {
//           image.removeClass('hovered');
//         }
//       });
//     }
  });
  
  $(window).resize(function() {
    var headerHeight = $('header').outerHeight(true);
    offset = headerHeight;
    elementPosition = $('.hero').outerHeight(true);
    if ($(window).width() < 1000) {
      $('.pdp-scents .carousel').scrollLeft($('.pdp-scents .scent').width()/2);
    }
  });
  
//   Shopify.queryParams = {};
//   let searchParams = new URLSearchParams(window.location.search)
  if (window.location.search.indexOf("sort_by") > -1) {
    var t = setTimeout(function() {
      $('html, body').animate({scrollTop: $('#collection').offset().top -100 }, 0);
    }, 2000);
  }
  document.querySelector('#sort-select').addEventListener('change', function() {
    window.location = this.value;
  });
//   jQuery('.collection-filtered .sort select').on('change', function() {
//     const urlSearchParams = new URLSearchParams(window.location.search);
//     urlSearchParams.set(this.name, this.value);
//     window.location = `?${urlSearchParams}`;
//     var value = $(this).find('option:selected').attr('value');
//     Shopify.queryParams.sort_by = value;
//     location.search = jQuery.param(Shopify.queryParams);
//   });
  
  var products = $('.collection-filtered .product-card');
  $('.collection-filtered input[type="checkbox"]').on('change', function(e) {
      var typeTags = [];
      var catTags = [];
      var scentTags = [];
      e.preventDefault();
      if ($(this).hasClass('everything')) {
          $(this).closest('.filter').find('input[type="checkbox"]:not(.everything)').prop( "checked", false );
      } else {
          $(this).closest('.filter').find('.everything').prop( "checked", false );
      }
      if (!$('.filter').find('input[type="checkbox"]:not(.everything):checked').length) {
          $(this).closest('.filter').find('.everything').prop( "checked", true );
      }
      if ($('.filters input.everything:checked').length != $('.filters .filter').length) {
        $('.filters input:not(.everything):checked').each(function() {
          var filterTags = $(this).attr('data-tag').split(',');
          for (var i=0; i<filterTags.length; i++) {
            if ($(this).closest('.filter').attr('data-filter') == 'type') {
              typeTags.push(filterTags[i]);
            } else if ($(this).closest('.filter').attr('data-filter') == 'category') {
              catTags.push(filterTags[i]);
            } else if ($(this).closest('.filter').attr('data-filter') == 'scent') {
              scentTags.push(filterTags[i]);
            }
          }
        });
      }
      if ($(window).width() >= 1000) {
        filterProducts(typeTags, catTags, scentTags);
      }
  });
  
  $('.collection-filtered .filters .button').click(function(e) {
    e.preventDefault();
    if ($(window).width() < 1000) {
      var typeTags = [];
      var catTags = [];
      var scentTags = [];
      if ($('.filters input.everything:checked').length != $('.filters .filter').length) {
        $('.filters input:not(.everything):checked').each(function() {
          var filterTags = $(this).attr('data-tag').split(',');
          for (var i=0; i<filterTags.length; i++) {
            if ($(this).closest('.filter').attr('data-filter') == 'type') {
              typeTags.push(filterTags[i]);
            } else if ($(this).closest('.filter').attr('data-filter') == 'category') {
              catTags.push(filterTags[i]);
            } else if ($(this).closest('.filter').attr('data-filter') == 'scent') {
              scentTags.push(filterTags[i]);
            }
          }
        });
      }
      filterProducts(typeTags, catTags, scentTags);
      $('.filters').hide(0);
    }
  });
  
  function filterProducts(typeTags, catTags, scentTags) {
    var filteredProducts = [];
    if (typeTags.length || catTags.length || scentTags.length) {
      products.each(function() {
        var counter = 0;
        var tags = $(this).attr('data-tags').split(',');
        if (!typeTags.length) {
          counter++;
        } else {
          for (var j=0; j<tags.length; j++) {
            if (typeTags.includes(tags[j])) {
              counter ++;
              break;
            }
          }
        }
        if (!catTags.length) {
          counter++;
        } else {
          for (var j=0; j<tags.length; j++) {
            if (catTags.includes(tags[j])) {
              counter ++;
              break;
            }
          }
        }
        if (!scentTags.length) {
          counter++;
        } else {
          for (var j=0; j<tags.length; j++) {
            if (scentTags.includes(tags[j])) {
              counter ++;
              break;
            }
          }
        }
        if (counter == $('.filter').length) {
          filteredProducts.push($(this));
        }
      });
      $('.collection-grid').html('');
      for (var i=0; i<filteredProducts.length; i++) {
        $('.collection-grid').append(filteredProducts[i]);
      }
    } else {
      $('.collection-grid').html(products);
    }
  }
  
  $('#open-mobile-filters').click(function(e) {
    e.preventDefault();
    $('.collection-filtered .filters').slideToggle(0);
  });
  $('.filters .close').click(function(e) {
    e.preventDefault();
    $('.collection-filtered .filters').slideToggle(0);
  });

  $('.product-card').each(function() {
    if ($(this).find('.review-badges').length) {
      var totalScore = 0;
      var reviewNum = 0;
      var badgeNum = 0;
      $(this).find('.jdgm-widget').each(function() {
        var data = $(this).find('.jdgm-prev-badge');
        totalScore += +data.data('average-rating');
        reviewNum += +data.data('number-of-reviews');
        badgeNum++;
      });
      var average_score = totalScore / badgeNum;
      var reviewStarsArray = '';
      for (var i=0; i<5; i++) {
        if ((average_score - i) >= 1) reviewStarsArray += `<span class="jdgm-star jdgm--on"></span>`;
        else if ((average_score - i) < 1 && (average_score - i) > 0) reviewStarsArray += `<span class="jdgm-star jdgm--half"></span>`;
        else if ((average_score - i) < 0)  reviewStarsArray += `<span class="jdgm-star jdgm--off"></span>`;
      }
      var widget = `<div style="" class="jdgm-widget jdgm-preview-badge jdgm-hidden jdgm--done-setup" data-template="manual-installation" data-auto-install="false">
      <div class="jdgm-prev-badge">
      <span class="jdgm-prev-badge__stars"role="button">${reviewStarsArray}</span>
      <span class="jdgm-prev-badge__text">${reviewNum} reviews</span>
      </div></div>`;
      if (reviewNum) {
        $(this).find('.review-badges').after(widget);
      }
    }
  })
});